export type TimeWindow = {
  startHour: number;
  startMinutes: number;
  endHour: number;
  endMinutes: number;
};

export function isWithinWorkingHours(
  range: TimeWindow,
  officeHours: TimeWindow
): boolean {
  // Convert hours and minutes to minutes since start of day for easier comparison
  const rangeStart = range.startHour * 60 + range.startMinutes;
  const rangeEnd = range.endHour * 60 + range.endMinutes;
  const officeHoursStartMinutes =
    officeHours.startHour * 60 + officeHours.startMinutes;
  const officeHoursEndMinutes =
    officeHours.endHour * 60 + officeHours.endMinutes;

  // if defined start or end is within the current start and end, then the office is open
  if (
    (rangeStart >= officeHoursStartMinutes &&
      rangeStart <= officeHoursEndMinutes) ||
    (rangeEnd >= officeHoursStartMinutes && rangeEnd <= officeHoursEndMinutes)
  ) {
    return true;
  }

  // If defined time window is exactly the same as working hours, it is also considered within working hours
  if (
    rangeStart === officeHoursStartMinutes &&
    rangeEnd === officeHoursEndMinutes
  ) {
    return true;
  }

  // In all other cases the office is closed
  return false;
}
